const dyzioPalette = {
  pink: '#fc4085',
  bgPink: '#ffecf3',
  green: '#20c49e',
  bgGreen: '#d4faf1',
  amber: '#fdb02b',
  bgAmber: '#fff1d5',
  blue: '#9ad2ff',
  bgBlue: '#323299',
};

module.exports.reportData = {
  info: {
    campaignName: 'SNICKERS 2017',
    influencerName: 'Callux',
    reportDate: new Date('2017-12-05'),
    hasLogo: true,
  },
  youtubeViews: 323666,
  youtubeEngagements: 17216,
  supportingActivity: [
    {
      platform: 'instagram',
      title: 'Instagram Story 1',
      views: 77294,
      screenshot: '/images/screenshots/callux-snickers-instagram-stories.jpeg',
    },
    {
      platform: 'instagram',
      title: 'Instagram Story 2',
      views: 91928,
      screenshot: '/images/screenshots/callux-snickers-instagram-stories.jpeg',
    },
    {
      platform: 'twitter',
      url: 'https://twitter.com/Callux/status/937690796333109248',
      title: 'DID YOU CATCH MY VIDEO BEFORE MY VIDEO LAST NIGHT?',
      views: 65216,
      engagements: 2086,
      screenshot: '/images/screenshots/callux-snickers-tweet.jpeg',
    },
  ],
  heroData: {
    main: {
      title: 'ACTING PRANK with JOSH',
      subTitle: 'Acting with the public and Josh. Call your friends out with a Snickers Hunger Bar - Paid promotion for Snickers',
      videoUrl: 'https://www.youtube.com/watch?v=isfFob-lHcY',
      views: 323666,
      engagements: 17216,
      watchTimeUKIre: 514960,
      watchTimeTotal: 996070,
      donutData: {
        labels: [
          'male %',
          'female %',
        ],
        datasets: [{
          data: [88.6, 11.4],
          backgroundColor: [
            dyzioPalette.bgPink,
            dyzioPalette.bgGreen,
          ],
          borderColor: [
            dyzioPalette.pink,
            dyzioPalette.green,
          ],
          borderWidth: 1,
        }],
      },
      barData: {
        labels: ['13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '64+'],
        datasets: [
          {
            label: 'male %',
            backgroundColor: dyzioPalette.bgPink,
            borderColor: dyzioPalette.pink,
            borderWidth: 1,
            data: [10.3, 35.7, 26.6, 8.3, 5.5, 1, 1.3],
          },
          {
            label: 'female %',
            backgroundColor: dyzioPalette.bgGreen,
            borderColor: dyzioPalette.green,
            borderWidth: 1,
            data: [1.7, 4.6, 2.4, 1.3, 1, 0.2, 0.2],
          },
        ],
      },
      viewingData: [{
        name: 'United Kingdom',
        watchTime: 485181,
        views: 148235,
      },
      {
        name: 'United States',
        watchTime: 68518,
        views: 23156,
      },
      {
        name: 'Mexico',
        watchTime: 30782,
        views: 12555,
      },
      {
        name: 'Australia',
        watchTime: 40189,
        views: 12225,
      },
      {
        name: 'Ireland',
        watchTime: 29779,
        views: 9501,
      },
    ],
    },
    supportingData: {
      labels: [
        'instagram story',
        'twitter',
      ],
      datasets: [{
        data: [169222, 65216],
        backgroundColor: [
          dyzioPalette.bgPink,
          dyzioPalette.blue,
        ],
        borderColor: [
          dyzioPalette.pink,
          dyzioPalette.bgBlue,
        ],
        borderWidth: 1,
      }],
    },
  },
};



// WEBPACK FOOTER //
// ./src/containers/campaign-report/data/callux-snickers-2017.js